import { render, staticRenderFns } from "./SoftPowerResultTable.vue?vue&type=template&id=c5a1e4ba&scoped=true&"
import script from "./SoftPowerResultTable.vue?vue&type=script&lang=js&"
export * from "./SoftPowerResultTable.vue?vue&type=script&lang=js&"
import style0 from "./SoftPowerResultTable.vue?vue&type=style&index=0&id=c5a1e4ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a1e4ba",
  null
  
)

export default component.exports